import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useHandleServerError } from "Infrastructure/Utilities/Forms/Hooks/useHandleServerError";
import { useCreateUserRole } from "Settings/User/Api/Mutation/createUserRoleMutation";
import PermissionsSection from "Settings/User/Components/Form/PermissionsSection";
import {
	getUserRolesCreateFormModelSchema,
	type UserRolesCreateFormModel,
} from "Settings/User/Components/Form/Schema/userRolesCreateFormSchema";
import Input from "Shared/Components/Form/CustomFormComponent/Input";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { Scrollbar } from "../../../../Shared/Components/Scroll/Scrollbar";

const defaultValues = {
	name: "",
	permissions: [],
};

const userResource = Resources.base.user.roles;

export const UserRolesCreateForm = () => {
	const { t } = useResource();

	const form = useForm<UserRolesCreateFormModel>({
		resolver: zodResolver(getUserRolesCreateFormModelSchema()),
		defaultValues: defaultValues,
	});

	const {
		control,
		formState: { errors },
	} = form;

	const { mutate: createUserRole, isPending } = useCreateUserRole();

	const { handleServerError } = useHandleServerError(form);

	const handleSubmitRolesUpdate = () => {
		handleServerError(createUserRole, {
			onSuccess: () => form.reset(defaultValues),
		});
	};

	return (
		<form>
			<Stack spacing={2}>
				<Input
					id="name"
					name="name"
					label={t(userResource.name)}
					variant="outlined"
					control={control}
					errors={errors}
					fullWidth
				/>
				<Scrollbar sx={{ maxHeight: 400 }}>
					<PermissionsSection form={form} />
				</Scrollbar>
				<Button
					fullWidth
					variant="contained"
					onClick={handleSubmitRolesUpdate}
					loading={isPending}
				>
					{t(userResource.save)}
				</Button>
			</Stack>
		</form>
	);
};
